import { render, staticRenderFns } from "./ApplicantOnboardingCDCRequest.vue?vue&type=template&id=099cbfea&"
import script from "./ApplicantOnboardingCDCRequest.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingCDCRequest.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOnboardingCDCRequest.vue?vue&type=style&index=0&id=099cbfea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports